import { render, staticRenderFns } from "./DashboardContainer.vue?vue&type=template&id=7e56d53b&"
import script from "./DashboardContainer.vue?vue&type=script&lang=js&"
export * from "./DashboardContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports